import React from "react";
import sliderContent from "../../../assets/images/chpt/slider-content.png";
import { Button } from "reactstrap";
import { motion } from "framer-motion/dist/framer-motion";
import {
  staticBounceVariants
  
} from "shared/components/animations";
const CardSlider = ({
  currentPlayerCard,
  showButton = false,
  selectCard = () => {}
}) => {
  return (
  
      <motion.div  variants={staticBounceVariants} className="players-cards">
        {currentPlayerCard?.map((value, index) => (
          <div className={`card ${showButton? "button":" "}`} onClick={() => selectCard(value)} key={index}>
            <img src={value?.url} alt="sliderContent" />
            {showButton && <Button className="primary-solid">CHOOSE</Button>}
          </div>
        ))}
      </motion.div>
  
  );
};

export default CardSlider;
